// Created by 任泽阳 on 18/12/25.
// 公共部分路由 (三站公用的路由)
import { routerEnv } from '@/utils';
import pcRouter from '../../router/common-router';
import assetsRouter from '../../router/assetsRouter';

export default [
  ...pcRouter,
  // VDN 白皮书
  {
    path: `${routerEnv}/vdnPaper`,
    name: 'vdnPaper',
    meta: {
      pageTitle: 'vdnPaper',
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      footNotMrgin: true,
      hideFooter: true, // 不隐藏footer
      H5HideCommonHeader: true, // H5 隐藏公共导航
      isCoOpen: true,
    },
    component: () => import('@/views/vdnPaper.vue'),
  },
  // mmf预告页
  {
    path: `${routerEnv}/mmfLoading`,
    name: 'mmfLoading',
    meta: {
      pageTitle: 'mmfLoading',
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      footNotMrgin: true,
      hideFooter: true, // 不隐藏footer
      H5HideCommonHeader: true, // H5 隐藏公共导航
      isCoOpen: true,
    },
    component: () => import('@/views/mmfLoading.vue'),
  },
  // 我的邀请
  {
    path: `${routerEnv}/myInvite`,
    name: 'personal',
    meta: {
      pageTitle: 'landingPage',
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      footNotMrgin: true,
      hideFooter: 'false', // 不隐藏footer
      H5HideCommonHeader: true, // H5 隐藏公共导航
      isCoOpen: true,
    },
    component: () => import('@/views/personal/myInvite.vue'),
  },
  // mmf 首页
  // {
  //   path: `${routerEnv}/mmf`,
  //   name: 'mmf',
  //   redirect: '/mmf/mmfIndex',
  //   // meta: {
  //   //   theme: 'homeOther',
  //   //   navigation: '1', // 国际版中使用横向导航
  //   //   hideFooter: 'false', // 不隐藏footer
  //   //   pageTitle: 'mmf',
  //   // },
  //   component: () => import('@/views/mmf/index.vue'),
  //   children: [
  //     // mmf首页
  //     {
  //       path: 'mmfIndex',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfIndex',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/mmfIndex.vue'),
  //     },
  //     // mmf购买页面
  //     {
  //       path: 'mmfBuy',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfBuy',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/mmfBuy.vue'),
  //     },
  //     // mmf优惠券页面
  //     {
  //       path: 'mmfCoupons',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfCoupons',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/mmfCoupons.vue'),
  //     },
  //     // mmf账户页面
  //     {
  //       path: 'mmfAccount',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfAccount',
  //         pageTitle: 'mmf',
  //         scrollH: 0,
  //       },
  //       component: () => import('@/views/mmf/mmfAccount.vue'),
  //     },
  //     // mmf超级节点
  //     {
  //       path: 'mmfSuperPeer',
  //       name: 'mmfSuperPeer',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfSuperPeer',
  //         pageTitle: 'mmf',
  //         scrollH: 0,
  //       },
  //       component: () => import('@/views/mmf/superPeer.vue'),
  //     },
  //     // mmf 详情页面
  //     {
  //       path: 'mmfDetail',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfDetail',
  //         pageTitle: 'mmf',
  //         scrollH: 0,
  //       },
  //       component: () => import('@/views/mmf/mmfDetail.vue'),
  //     },
  //     // mmf 日产出/累计产出页面
  //     {
  //       path: 'outputDetail',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'outputDetail',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/outputDetail.vue'),
  //     },
  //     // mmf 可用FIL页面
  //     {
  //       path: 'mmfFil',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfFil',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/mmfFil.vue'),
  //     },
  //     // mmf 已封装算力页面
  //     {
  //       path: 'hashrate',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'hashrate',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/hashrate.vue'),
  //     },
  //     // mmf 交易记录页面
  //     {
  //       path: 'tradingRecords',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'tradingRecords',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/tradingRecords.vue'),
  //     },
  //     // mmf 超级节点页面
  //     {
  //       path: 'mmfNode',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfNode',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/mmfNode.vue'),
  //     },
  //     // mmf 相关协议
  //     {
  //       path: 'mmfDeal',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: true,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfDeal',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/mmfDeal.vue'),
  //     },
  //     // mmf FAQ
  //     {
  //       path: 'mmfFaq',
  //       name: 'mmf',
  //       meta: {
  //         mustLogin: false,
  //         // hideFooter: true,
  //         activeName: 'mmf',
  //         navName: 'mmfFaq',
  //         pageTitle: 'mmf',
  //       },
  //       component: () => import('@/views/mmf/mmfFaq.vue'),
  //     },
  //   ],
  // },
  // landingPage
  {
    path: `${routerEnv}/landingPage`,
    name: 'landingPage',
    meta: {
      pageTitle: 'landingPage',
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      footNotMrgin: true,
      hideFooter: 'false', // 不隐藏footer
      H5HideCommonHeader: true, // H5 隐藏公共导航
      isCoOpen: true,
    },
    component: () => import('@/views/landingPage/index.vue'),
  },
  // 经纪人系统 列表
  {
    path: `${routerEnv}/broker`,
    name: 'broker',
    meta: {
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
      pageTitle: 'broker',
    },
    component: () => import('@/views/broker/index.vue'),
  },
  // 资金管理
  {
    path: `${routerEnv}/assets`,
    name: 'assets',
    component: () => import('@/views/assets/index.vue'),
    children: [
      ...assetsRouter,
      // 币宝账户
      {
        path: 'bibaoAccount',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'bibaoAccount',
        },
        component: () => import('@/views/assets/bibaoAccount.vue'),
      },
      // 币宝详情
      {
        path: 'bibaoDetail',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'bibaoDetail',
        },
        component: () => import('@/views/assets/bibaoDetail.vue'),
      },
      // b2c账户
      {
        path: 'b2cAccount',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'b2cAccount',
          activeName: 'assets',
        },
        component: () => import('@/views/assets/b2cAccount.vue'),
      },
      // b2c账户
      {
        path: 'b2cRecrge',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'b2cAccount',
          activeName: 'assets',
        },
        component: () => import('@/views/assets/b2cRecrge.vue'),
      },
      // b2c账户
      {
        path: 'b2cWithdraw',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'b2cAccount',
          activeName: 'assets',
        },
        component: () => import('@/views/assets/b2cWithdraw.vue'),
      },
      // b2c账户
      {
        path: 'b2cAddressMent',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'b2cAccount',
          activeName: 'assets',
        },
        component: () => import('@/views/assets/b2cAddressMent.vue'),
      },
      // b2c账户
      {
        path: 'b2cAdd',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'b2cAccount',
          activeName: 'assets',
        },
        component: () => import('@/views/assets/b2cAdd.vue'),
      },
      // b2c账户
      {
        path: 'b2cFlowingWater',
        name: 'assets',
        meta: {
          mustLogin: true,
          navName: 'b2cFlowingWater',
          activeName: 'assets',
        },
        component: () => import('@/views/assets/b2cFlowingWater.vue'),
      },
    ],
  },
  // 理财宝详情页
  {
    path: `${routerEnv}/manageFinances/:id`,
    name: 'manageFinancesView',
    meta: {
      mustLogin: true,
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
    },
    component: () => import('@/views/manageFinances/view.vue'),
  },
  // 理财宝首页
  {
    path: `${routerEnv}/manageFinances`,
    name: 'manageFinances',
    meta: {
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
    },
    component: () => import('@/views/manageFinances/list.vue'),
  },
  // 理财宝订单页
  {
    path: `${routerEnv}/manageFinancesOrder`,
    name: 'manageFinancesOrder',
    meta: {
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
    },
    component: () => import('@/views/manageFinances/orderList.vue'),
  },
  {
    path: `${routerEnv}/questions`,
    name: 'questions',
    redirect: '/questions/init',
    meta: {
      theme: '',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
      mustLogin: true,
    },
    component: () => import('@/views/problemCenter/index.vue'),
    children: [
      {
        path: 'init',
        name: 'questions',
        meta: {
          theme: '',
          navigation: '1', // 国际版中使用横向导航
          hideFooter: 'false', // 不隐藏footer
          mustLogin: true,
          activeName: '/questions/init',
        },
        component: () => import('@/views/problemCenter/initQuestions.vue'),
      },
      {
        path: 'list',
        name: 'questions',
        meta: {
          theme: '',
          navigation: '1', // 国际版中使用横向导航
          hideFooter: 'false', // 不隐藏footer
          mustLogin: true,
          activeName: '/questions/list',
        },
        component: () => import('@/views/problemCenter/questionsList.vue'),
      },
      {
        path: 'questionsDetails',
        name: 'questions',
        meta: {
          theme: '',
          navigation: '1', // 国际版中使用横向导航
          hideFooter: 'false', // 不隐藏footer
          mustLogin: true,
          activeName: '/questions/list',
        },
        component: () => import('@/views/problemCenter/questionsDetails.vue'),
      },
    ],
  },
  // 行情页面
  {
    path: `${routerEnv}/market`,
    name: 'market',
    meta: {
      footNotMrgin: true,
    },
    component: () => import('@/views/market/index.vue'),
  },
  {
    path: `${routerEnv}/freeStaking`,
    name: 'freeStaking',
    meta: {
      mustLogin: false,
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
      footNotMrgin: true,
    },
    component: () => import('@/views/freeStaking/home/index.vue'),
  },
  {
    path: `${routerEnv}/freeStaking/:id`,
    name: 'freeStakingDetail',
    meta: {
      mustLogin: false,
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
    },
    component: () => import('@/views/freeStaking/detail/index.vue'),
  },
  {
    path: `${routerEnv}/myPos`,
    name: 'myPos',
    meta: {
      mustLogin: true,
      theme: 'homeOther',
      navigation: '1', // 国际版中使用横向导航
      hideFooter: 'false', // 不隐藏footer
    },
    component: () => import('@/views/freeStaking/myPos/index.vue'),
  },
];
